@if(inputForm && fieldKey && fieldConfig){
<div>
  <ng-container *transloco="let t">
    <form [formGroup]="inputForm">
      @if ((fieldConfig.pricingItemValues?.length ?? 0) > 0) {
      <app-select [hasDefault]="true" [items]="options" [label]="fieldLabel" [formControlName]="fieldKey"
        [defaultValue]="undefined" [valueKey]="'id'" [translatedLabels]="labels" />
      } @else {
      <app-checkbox [formControlName]="fieldKey" [label]="fieldLabel" />
      }
    </form>
  </ng-container>
</div>
}